// extracted by mini-css-extract-plugin
export var menuItem = "J_wk d_fZ d_by d_bC d_bN d_bd";
export var menuItemSub = "J_wl d_Y d_by d_bN";
export var menuMainLink = "J_wm d_f0 d_dz";
export var menuLink = "J_wn d_f0 d_dz";
export var icon = "J_pD d_bB d_bN";
export var divider = "J_wp d_bB d_bN";
export var sublinks = "J_wq";
export var link = "J_mC";
export var Link = "J_s8 B_s8 B_sq B_sL";